import { render, staticRenderFns } from "./SelectorLanguages.vue?vue&type=template&id=99465032&scoped=true&"
import script from "./SelectorLanguages.vue?vue&type=script&lang=js&"
export * from "./SelectorLanguages.vue?vue&type=script&lang=js&"
import style0 from "./SelectorLanguages.vue?vue&type=style&index=0&id=99465032&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99465032",
  null
  
)

export default component.exports